// Unpublished Work © 2023 Deere & Company.

import { useContext } from "react";
import { ApiContext } from "../../context/ApiContext/ApiContext";
import { ConfigContext } from "../../context/ConfigContext";
import { CategoryKey, ToggleKey } from "../../pages/featureToggles/constants";
import {
  FeatureToggleDetail,
  FeatureToggleStatus,
} from "../../pages/featureToggles/types";

const FeatureToggleApiV2 = () => {
  const axios = useContext(ApiContext);
  const { FEATURE_TOGGLE_SERVICE_URL: baseUrl } = useContext(ConfigContext);
  const apiV1Url = `${baseUrl}/feature-toggles/v1`;

  const getFeatureToggleStatus = async (
    categoryKey: CategoryKey,
    toggleKey: ToggleKey,
    country: string,
    account?: string,
    branch?: string
  ) =>
    axios
      .getWithRetries<FeatureToggleStatus>(
        `${apiV1Url}/${categoryKey}/toggle/${toggleKey}/status`,
        {
          params: {
            country,
            branch,
            accounts: account,
          },
        }
      )
      .then((res) => res.data);

  return {
    getFeatureToggles: async (): Promise<FeatureToggleDetail[]> =>
      axios
        .getWithRetries<FeatureToggleDetail[]>(`${apiV1Url}`)
        .then((res) => res.data),
    saveFeatureToggles: (
      data: FeatureToggleDetail
    ): Promise<FeatureToggleDetail> =>
      axios
        .putWithRetries<FeatureToggleDetail>(`${apiV1Url}`, data)
        .then((res) => res.data),
    getAllFeatureToggleStatus: (
      country: string,
      branch?: string,
      accounts?: string
    ): Promise<FeatureToggleStatus[]> =>
      axios
        .getWithRetries<FeatureToggleStatus[]>(`${apiV1Url}/all/status`, {
          params: {
            country,
            branch,
            accounts,
          },
        })
        .then((res) => res.data),
    getFeatureToggleStatus,
  };
};

export default FeatureToggleApiV2;
